import React from 'react';
import {Link} from "react-router-dom";
import {faPencil} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useSelector} from "react-redux";
import {canInsertByLicense} from "../commonmethod/CommonMethod";

function MobileCreateButton({url, assetCheck, userCheck}) {
    const license = useSelector(state => state.auth.license);
    const canInsert = canInsertByLicense({ license, assetCheck, userCheck });

    return (
        <div className="z-10 web-hidden fixed w-[50px] h-[50px] bottom-[20px] right-[20px] rounded-2xl bg-[var(--main-bg-color)]">

            { url ?
                (canInsert
                    ? (
                        <Link className={`web-hidden fixed w-[50px] h-[50px] bottom-[20px] right-[20px] rounded-2xl bg-[var(--main-bg-color)]`} to={url ?? ''}>
                            <FontAwesomeIcon icon={faPencil}
                                             className={`w-[30px] h-[30px] text-center text-[var(--main-inner-color)] p-[10px] line-height-20`}/>
                        </Link>
                    )
                    : (
                        <button type="button" className={` z-999 web-hidden fixed w-[50px] h-[50px] bottom-[20px] right-[20px] rounded-2xl bg-[var(--main-inner-color)]`}>
                            <FontAwesomeIcon icon={faPencil}
                                             className={`w-[30px] h-[30px] text-center text-[var(--main-inner-color)] p-[10px] line-height-20`}/>
                        </button>
                    ))
                : ""
            }

        </div>
    );
}

export default MobileCreateButton;
